import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { layerStyles } from "theme/layer-styles";
import { textStyles } from "theme/text-styles";

export const Link: ComponentStyleConfig = {
  baseStyle: {
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    whiteSpace: "pre-wrap",
    fontWeight: "semibold",
    borderRadius: "tinier", // Gives a friendly rounded focus border
    _hover: {
      textDecoration: "none",
    },
    _focus: {
      outline: "none !important",
    },
    _focusVisible: {
      borderColor: "transparent",
      boxShadow: "outline",
    },
  },
  sizes: {
    xs: {
      fontSize: "xs",
    },
    sm: {
      fontSize: "sm",
    },
    md: {
      fontSize: "md",
    },
    lg: {
      fontSize: "lg",
    },
    xl: {
      fontSize: "xl",
    },
  },
  variants: {
    inline: {
      position: "relative",
      display: "inline",
      fontSize: "inherit",
      fontWeight: "inherit",
      color: "new.green.700",
      textDecoration: "underline",
      textUnderlineOffset: "2px",
      _hover: {
        color: "unset",
        textDecoration: "underline",
      },
    },
    inlineDark: {
      position: "relative",
      display: "inline",
      fontSize: "inherit",
      fontWeight: "inherit",
      textDecoration: "underline",
      textUnderlineOffset: "2px",
      _hover: {
        color: "new.green.700",
        textDecoration: "underline",
      },
    },
    nav: {
      ...textStyles.caption1,
      borderRadius: "base",
      fontWeight: "normal",
      pos: "relative",
      w: "100%",
      height: "100%",
      transition: "all 0.15s ease-in-out",
    },
    navMobile: {
      ...textStyles.headline2,
      fontWeight: "semibold",
      py: "smallest",
    },
    footer: {
      ...textStyles.caption2,
      display: "flex",
      alignItems: "center",
      color: "brand.text.dark",
      gap: "tiny",
      fontWeight: "normal",
    },
    sidebar: {
      ...textStyles.caption1,
      borderRadius: "tiny",
      fontWeight: "normal",
      my: "tiniest",
      px: "tiny",
      py: "tinier",
      _hover: { bg: "brand.backgroundSecondary.light" },
    },
    unstyled: {
      textDecoration: "none",
      fontWeight: "normal",
      fontSize: "base",
      _hover: {
        textDecoration: "none",
      },
    },
    lightShadowCard: {
      ...layerStyles.card.shadow.light,
      mt: "tiny",
      _hover: {
        transform: "translateY(-8px)",
      },
    },
    // -----------------------------------
    // Legacy link styles
    // -----------------------------------
    default: {
      color: "inherit",
      _hover: {
        color: "grass",
      },
    },
    white: {
      color: "white",
      _hover: {
        color: "mint",
      },
    },
    dark: {
      color: "text.primary",
      _hover: {
        color: "gray.800",
      },
    },
    grass: {
      color: "grass",
      _hover: {
        color: "grassLight",
      },
    },
    teal: {
      color: "teal",

      _hover: {
        color: "tealLight",
      },
    },
    mint: {
      color: "mint",

      _hover: {
        color: "mintLight",
      },
    },
    ocean: {
      color: "ocean",

      _hover: {
        color: "oceanLight",
      },
    },
    plum: {
      color: "plum",

      _hover: {
        color: "plumLight",
      },
    },
    article: {
      color: "inherit",
      fontSize: "inherit",
      fontWeight: "inherit",
      fontFamily: "inherit",
      textDecoration: "underline",
      textUnderlineOffset: 3,
      _hover: {
        color: "grass",
        textDecoration: "underline",
      },
    },
  },
  defaultProps: {
    variant: "default",
    size: "md",
  },
};
